import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: colors.pink,
        secondary: colors.grey.lighten1,
        accent: colors.pink.lighten2
      },
      dark: {
        primary: colors.pink.darken1,
        secondary: colors.grey.darken4,
        accent: colors.pink.darken3
      }
    }
  }
})
